export type ReactionId =
  | "triumph_wooo"
  | "happy_affirm"
  | "happy_laugh"
  | "sad_sigh"
  | "sad_wailing"
  | "fear_gasp"
  | "fear_scream"
  | "anger_growl"
  | "anger_shout"
  | "disgust_tongue"
  | "disgust_yuck"
  | "surprise_inhale"
  | "contempt_tsk"
  | "contempt_snort"
  | "confused"
  | "sleepy_snore"
  | "eating_munch";

export const EMOTION_CATALOG: Array<{
  id: ReactionId;
  label: string;
  description: string;
  hue: string;
}> = [
  { id: "triumph_wooo", label: "Triumph", description: "Peak hype", hue: "linear-gradient(120deg,#ff8a00,#e52e71)" },
  { id: "happy_affirm", label: "Happy Affirm", description: "Upbeat nod", hue: "linear-gradient(120deg,#2af598,#009efd)" },
  { id: "happy_laugh", label: "Happy Laugh", description: "Full laugh", hue: "linear-gradient(120deg,#f857a6,#ff5858)" },
  { id: "sad_sigh", label: "Sad Sigh", description: "Soft sigh", hue: "linear-gradient(120deg,#434343,#000000)" },
  { id: "sad_wailing", label: "Sad Wail", description: "Open sob", hue: "linear-gradient(120deg,#4e4376,#2b5876)" },
  { id: "fear_gasp", label: "Fear Gasp", description: "Sharp gasp", hue: "linear-gradient(120deg,#b24592,#f15f79)" },
  { id: "fear_scream", label: "Fear Scream", description: "Full scream", hue: "linear-gradient(120deg,#603813,#b29f94)" },
  { id: "anger_growl", label: "Anger Growl", description: "Low growl", hue: "linear-gradient(120deg,#ff512f,#dd2476)" },
  { id: "anger_shout", label: "Anger Shout", description: "Fiery shout", hue: "linear-gradient(120deg,#f00000,#dc281e)" },
  { id: "disgust_tongue", label: "Disgust Tongue", description: "Tongue out", hue: "linear-gradient(120deg,#56ab2f,#a8e063)" },
  { id: "disgust_yuck", label: "Disgust Yuck", description: "Utter yuck", hue: "linear-gradient(120deg,#16a085,#f4d03f)" },
  { id: "surprise_inhale", label: "Surprise", description: "Sharp inhale", hue: "linear-gradient(120deg,#00d2ff,#3a7bd5)" },
  { id: "contempt_tsk", label: "Contempt Tsk", description: "Dismissive", hue: "linear-gradient(120deg,#bdc3c7,#2c3e50)" },
  { id: "contempt_snort", label: "Contempt Snort", description: "Annoyed", hue: "linear-gradient(120deg,#485563,#29323c)" },
  { id: "confused", label: "Confused", description: "Perplexed", hue: "linear-gradient(120deg,#8360c3,#2ebf91)" },
  { id: "sleepy_snore", label: "Sleepy", description: "Soft snore", hue: "linear-gradient(120deg,#141e30,#243b55)" },
  { id: "eating_munch", label: "Eating", description: "Crunch time", hue: "linear-gradient(120deg,#f2994a,#f2c94c)" }
];

export const TOTAL_REACTIONS = EMOTION_CATALOG.length;
